/** An enum of marker icon values. */
export const markerIcons = {
    DefaultPin: "DefaultPin",
    ColoredPin: "ColoredPin",
    TwoTonedCircle: "TwoTonedCircle"
}

export const markerIconsEnum = {
    [markerIcons.DefaultPin]: 1,
    [markerIcons.ColoredPin]: 2,
    [markerIcons.TwoTonedCircle]: 3
}

export const defaultPin = {
    value: markerIcons.DefaultPin,
    text: "Pin (monochrome)",
    description: "Default marker settings (pin icon, cannot be colourized)"
}

export const coloredPin = {
    value: markerIcons.ColoredPin,
    text: "Pin (coloured)",
    description: "Pin icon that uses the Current status colour"
}

export const twoTonedCircle = {
    value: markerIcons.TwoTonedCircle,
    text: "Two-toned Circle",
    description: "Circle marker with Declaration status colour on outside and Current status on inside"
}

/**
 * Return the corresponding marker icon value given the enum value.
 * @param {any} markerIconEnum
 */
export function getMarkerIcon(markerIconEnum) {
    // Map either the enum string value or numerical value to the object.
    switch (markerIconEnum) {
        case markerIcons.DefaultPin:
        case markerIconsEnum[markerIcons.DefaultPin]:
            return defaultPin;
        case markerIcons.ColoredPin:
        case markerIconsEnum[markerIcons.ColoredPin]:
            return coloredPin;
        case markerIcons.TwoTonedCircle:
        case markerIconsEnum[markerIcons.TwoTonedCircle]:
            return twoTonedCircle;
        default:
            return null;
    }
}
